/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SEND_OTP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.BuyInsurancePage.send.otp',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SEND_OTP' },
      },
    },
    SEND_OTP: {
      invoke: {
        id: 'sendOTP',
        src: 'sendOTP',
        onDone: {
          target: 'SEND_OTP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SEND_OTP_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SEND_OTP_SUCCESS: {
      on: {
        RE_SEND: { target: 'SEND_OTP' },
      },
    },
    SEND_OTP_FAILED: {
      on: {
        RE_SEND: { target: 'SEND_OTP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
